if (!customElements.get('option-component')) {
  class OptionComponent extends HTMLElement {
    constructor() {
      super();
      this.elements = {};
      this.state = {
        variants: [],
      };
    }

    connectedCallback() {
      this.init();
      this.initEvents();
    }

    disconnectedCallback() {}

    init() {
      this.elements.qtyInputs = this.querySelectorAll('quantity-input');
      this.elements.priceCells = this.querySelectorAll('.price-cell');
      this.elements.bulkOrderSummaryItemCount = document.querySelector(
        '.bulk-order-summary__item-count span',
      );
      this.elements.bulkOrderSummarySubtotal = document.querySelector(
        '.bulk-order-summary__subtotal span',
      );
      this.elements.bulkAddToCart = document.querySelector('.bulk-add-to-cart');
      this.elements.bulkViewCart = document.querySelector('.bulk-view-cart');

      this.elements.variantId = this.dataset.variantId;
      // primaryPrice is already in dollars (from money_without_currency filter)
      this.elements.price = parseFloat(this.dataset.primaryPrice.replace(/\,/g, '')) || 0;

      // Parse price breaks if available
      // Note: break.price is in cents (Shopify format), need to convert to dollars
      if (this.dataset.priceBreaks) {
        try {
          const breaks = JSON.parse(this.dataset.priceBreaks);
          this.elements.priceBreaks = breaks.map((breakItem) => ({
            minimum_quantity: breakItem.minimum_quantity,
            price: breakItem.price / 100, // Convert from cents to dollars
          }));
        } catch (e) {
          this.elements.priceBreaks = [];
        }
      } else {
        this.elements.priceBreaks = [];
      }

      this.state.variants = Array.from(document.querySelectorAll('option-component'));
    }

    initEvents() {
      if (this.elements.qtyInputs.length === 0) return;
      this.elements.qtyInputs.forEach((input) => {
        input.addEventListener('change', this.handleQtyInputChange.bind(this));
      });
    }

    handleQtyInputChange(event) {
      const qty = parseInt(event.target.value) || 0;
      const variantId = this.elements.variantId;

      // Calculate price based on quantity and price breaks
      const unitPrice = this.getUnitPriceForQuantity(qty);
      const totalPrice = qty * unitPrice;

      const formatted = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(totalPrice);

      this.elements.priceCells.forEach((cell) => {
        cell.textContent = `${formatted}`;
      });

      this.elements.qtyInputs.forEach((input) => {
        if (input !== event.target) {
          input.value = qty;
        }
      });

      this.updateVariantState(variantId, qty);
      this.updateBulkOrderSummary();
    }

    getUnitPriceForQuantity(quantity) {
      // If no price breaks, use default price
      if (!this.elements.priceBreaks || this.elements.priceBreaks.length === 0) {
        return this.elements.price;
      }

      // Sort breaks by minimum_quantity descending to find the best match
      const sortedBreaks = [...this.elements.priceBreaks].sort(
        (a, b) => b.minimum_quantity - a.minimum_quantity,
      );

      // Find the break where quantity >= minimum_quantity
      const applicableBreak = sortedBreaks.find(
        (breakItem) => quantity >= breakItem.minimum_quantity,
      );

      // Return the price from the applicable break (already in dollars), or default price
      return applicableBreak ? applicableBreak.price : this.elements.price;
    }

    updateVariantState(variantId, quantity) {
      const existing = this.state.variants.find((v) => v.dataset.variantId === variantId);
      if (existing) {
        existing.dataset.quantity = quantity;
      }
    }

    getAllVariantsWithQty() {
      return this.state.variants.map((v) => ({
        variantId: v.dataset.variantId,
        quantity: parseInt(v.dataset.quantity || 0),
      }));
    }

    updateBulkOrderSummary() {
      const variantsWithQty = this.getAllVariantsWithQty();
      const totalQty = variantsWithQty.reduce((sum, v) => sum + (v.quantity || 0), 0);

      const totalSubtotal = variantsWithQty.reduce((sum, v) => {
        const component = this.state.variants.find(
          (comp) => comp.dataset.variantId === v.variantId,
        );

        if (!component) return sum;

        // Get unit price based on quantity and price breaks
        let unitPrice = parseFloat(component.dataset.primaryPrice.replace(/\,/g, '')) || 0;

        // Check if component has price breaks
        if (component.elements && component.elements.priceBreaks) {
          unitPrice = component.getUnitPriceForQuantity(v.quantity || 0);
        } else if (component.dataset.priceBreaks) {
          // Parse price breaks if not already parsed
          try {
            const priceBreaks = JSON.parse(component.dataset.priceBreaks);
            const sortedBreaks = [...priceBreaks].sort(
              (a, b) => b.minimum_quantity - a.minimum_quantity,
            );
            const applicableBreak = sortedBreaks.find(
              (breakItem) => (v.quantity || 0) >= breakItem.minimum_quantity,
            );
            if (applicableBreak) {
              // Price is in cents, convert to dollars
              unitPrice = applicableBreak.price / 100;
            }
          } catch (e) {
            // Use default price if parsing fails
          }
        }

        return sum + unitPrice * (v.quantity || 0);
      }, 0);

      this.elements.bulkOrderSummaryItemCount.textContent = totalQty;
      this.elements.bulkOrderSummarySubtotal.textContent = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(totalSubtotal);
    }
  }

  customElements.define('option-component', OptionComponent);
}
